import script from "./TonalityIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TonalityIcon.vue?vue&type=script&setup=true&lang=js"

import "./TonalityIcon.vue?vue&type=style&index=0&id=3bc8a342&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc8a342"]])

export default __exports__